import { DungeonDifficulty } from '../types';
import type { VirtualPetClassSettings } from '../types';

export type InteractionType = 'chat' | 'feed' | 'play' | 'rest';

export type PlayActionType = 'stroke' | 'ball' | 'feather' | 'laser';

export const PET_BALANCE = {
  decayPerMinute: {
    hunger: 0.08,
    energy: 0.05,
    happiness: 0.02
  },
  maxDecayMinutes: 24 * 60,
  interaction: {
    chat: { exp: 3, intimacy: 4, delta: { happiness: 5 } },
    feed: { exp: 5, intimacy: 2, delta: { hunger: -15, happiness: 4 } },
    play: { exp: 10, intimacy: 6, delta: { happiness: 10, energy: -8 } },
    rest: { exp: 15, intimacy: 1, delta: { energy: 20, health: 5 } }
  } as Record<InteractionType, { exp: number; intimacy: number; delta: Record<string, number> }>,
  playActions: {
    stroke: { exp: 5, intimacy: 8, delta: { happiness: 8, energy: -2 } },
    ball: { exp: 12, intimacy: 6, delta: { happiness: 12, energy: -10 } },
    feather: { exp: 8, intimacy: 5, delta: { happiness: 10, energy: -6 } },
    laser: { exp: 10, intimacy: 6, delta: { happiness: 11, energy: -8 } }
  } as Record<PlayActionType, { exp: number; intimacy: number; delta: Record<string, number> }>,
  freeStrokePerDay: 2,
  freeChatPerDay: 3,
  freeRestPerDay: 1,
  levelExpMultiplier: 100,
  evolution: {
    hatch: { level: 2, intimacy: 30 },
    branch: { level: 5, intimacy: 60 },
    final: { level: 10, intimacy: 80, dungeonClearCount: 5 }
  },
  dungeonEnergy: {
    easy: 10,
    normal: 20,
    hard: 30
  } as Record<DungeonDifficulty, number>,
  interactionCooldownSec: 10,
  persistDebounceMs: 1200,
  decayRefreshIntervalSec: 60
};

export const DEFAULT_VIRTUAL_PET_SETTINGS: VirtualPetClassSettings = {
  enabled: true,
  freeChatPerDay: PET_BALANCE.freeChatPerDay,
  freeRestPerDay: PET_BALANCE.freeRestPerDay,
  freeStrokePerDay: PET_BALANCE.freeStrokePerDay,
  interactionCooldownSec: PET_BALANCE.interactionCooldownSec
};
